import { FormControl } from "@ecco/ui/form-control";
import { FormErrorMessage } from "@ecco/ui/form-error";
import { FormLabel } from "@ecco/ui/form-label";
import { Input } from "@ecco/ui/input";
import { Field } from "formik";
import { styles } from "./baseFormStyles";
import type { SingleFieldProps } from "./baseFormsValidations";

export const NameField = ({
    error,
    isInvalid,
    header,
    id = "firstName",
    sx = {},
    testId,
    isSuccess,
}: SingleFieldProps) => {
    return (
        <FormControl mt={4} isInvalid={isInvalid} isRequired isSuccess={isSuccess}>
            <FormLabel htmlFor={id} sx={styles.formLabel}>
                {header}
            </FormLabel>
            <Field
                data-testid={testId}
                as={Input}
                id={id}
                name={id}
                type="text"
                sx={{ ...styles.formInput, ...sx }}
            />
            <FormErrorMessage>{error}</FormErrorMessage>
        </FormControl>
    );
};

export default NameField;
